import { RouteType } from "../types/route.type";
import LoginPage from "../pages/login/LoginPage";
import HomePage from "../pages/home/HomePage";
import ListPage from "../pages/list/ListPage";
import NotFoundPage from "../pages/notfound/NotFoundPage";
import TestPage from "../pages/test/TestPage";
import GroupPage from "../pages/group";

const publicRoutes: RouteType[] = [
  {
    id: "notfound",
    path: "*",
    component: NotFoundPage,
  },
  {
    id: "test",
    path: "/test",
    component: TestPage,
  },
];

const restrictedRoutes: RouteType[] = [
  {
    id: "login",
    path: "/login",
    component: LoginPage,
  },
];
const privateRoutes: RouteType[] = [
  {
    id: "/report/kqtt",
    path: "/report/kqtt",
    component: HomePage,
  },
  {
    id: "list",
    path: "/list/:code",
    component: ListPage,
  },
  {
    id: "group",
    path: "/group/:code",
    component: GroupPage,
  },
];

export { publicRoutes, restrictedRoutes, privateRoutes };
